import React, { createContext, useContext, useState } from 'react';
import { permissionsList } from '../types/permissionsList';

export interface UserType {
    User: {
        name: string;
        position: string;
        email: string;
        role: string;
        is_active: boolean;
    };
    //role: string;
    token: string;
    permissions?: permissionsList[]; 
}

interface AuthContextType {
    user: UserType | null; 
    login: (userData: UserType) => void;
    logout: () => void;
    hasPermission: (permission: string) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    //const navigate = useNavigate();
    const [user, setUser] = useState<UserType | null>(()=>{
        //Recupera el usuario del session storage y del localstorage al inicializar el estado
        const userInLocal = JSON.parse(localStorage.getItem('user') || 'null')
        const savedUser = sessionStorage.getItem('userAdmin') ;
        return savedUser ? JSON.parse(savedUser) : userInLocal;
    }); 

    const login = (userData: UserType) => {
        if(JSON.stringify(user) !== JSON.stringify(userData)) {
            setUser(userData);
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('token', userData.token);   
            sessionStorage.setItem('user', JSON.stringify(userData)); 
            sessionStorage.setItem('token', userData.token);
            //sessionStorage.setItem('permissions', JSON.stringify(userData.permissions || []));
        }
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('userAdmin');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token'); 
        //sessionStorage.removeItem('permissions');
    };

    const hasPermission = (permission: string): boolean => {
        if (!user || !user.permissions) return false;
        return user.permissions.some(p => p.permission_name === permission);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, hasPermission}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};
